const features = [
  {
    icon: 'ri-flashlight-line',
    title: 'Faster Discovery',
    description:
      'Find product information quickly without wasting hours searching through multiple sources. Our organized spreadsheet format puts everything at your fingertips.',
    image:
      'https://readdy.ai/api/search-image?query=Clean%20organized%20workspace%20with%20search%20light%20concept%20represented%20by%20warm%20glowing%20sphere%20on%20wooden%20desk%2C%20minimalist%20editorial%20photography%2C%20soft%20natural%20light%2C%20efficient%20speed%20theme%2C%20warm%20cream%20and%20sage%20tones%2C%20calm%20focused%20atmosphere&width=600&height=400&seq=feat-discovery-vb&orientation=landscape',
  },
  {
    icon: 'ri-layout-grid-line',
    title: 'Organized Categories',
    description:
      'Browse products through structured spreadsheet-style collections. Every category is neatly arranged so you can navigate shoes, hoodies, jackets, and more with ease.',
    image:
      'https://readdy.ai/api/search-image?query=Neatly%20organized%20grid%20of%20product%20cards%20on%20warm%20cream%20surface%2C%20minimalist%20editorial%20layout%20photography%2C%20soft%20natural%20light%2C%20structured%20clean%20design%20aesthetic%2C%20warm%20neutral%20tones%2C%20organized%20harmony%20concept&width=600&height=400&seq=feat-organized-vb&orientation=landscape',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Easy Comparison',
    description:
      'Compare features, categories and options before making decisions. Side-by-side listings help you evaluate products at a glance without switching between tabs.',
    image:
      'https://readdy.ai/api/search-image?query=Two%20columns%20of%20organized%20product%20information%20side%20by%20side%20on%20warm%20beige%20surface%2C%20minimalist%20comparison%20concept%2C%20soft%20natural%20lighting%2C%20clean%20editorial%20photography%2C%20balanced%20composition%2C%20neutral%20warm%20tones&width=600&height=400&seq=feat-compare-vb&orientation=landscape',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Beginner Friendly',
    description:
      'Simple guides help new users understand the product research process step by step. No technical skills required — just browse and discover what you need.',
    image:
      'https://readdy.ai/api/search-image?query=Open%20guidebook%20beside%20warm%20cup%20of%20coffee%20on%20clean%20wooden%20desk%2C%20soft%20natural%20light%2C%20welcoming%20beginner%20friendly%20atmosphere%2C%20minimalist%20editorial%20lifestyle%20photography%2C%20warm%20cream%20tones%2C%20inviting%20and%20gentle%20aesthetic&width=600&height=400&seq=feat-beginner-vb&orientation=landscape',
  },
];

export default function FeatureCards() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-4">
            Why Use VigorBuy Spreadsheet?
          </h2>
          <p className="text-foreground-500 max-w-2xl mx-auto leading-relaxed">
            Thousands of shoppers choose our organized research tools to save time, stay informed, and make smarter
            purchasing decisions across all product categories.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="group rounded-2xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 overflow-hidden"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={feat.image}
                  alt={feat.title}
                  title={feat.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                  <i className={`${feat.icon} text-primary-600 text-lg`}></i>
                </div>
                <h3 className="font-heading font-semibold text-base text-foreground-900 mb-2">{feat.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{feat.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}